<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 billing-value" id="billing-value">
  <po-widget>
    <span class="po-font-text-bold title po-hidden-sm"
      >Valor médio faturado por dia da semana</span
    >
    <span class="po-font-text-bold title po-hidden-md po-hidden-lg po-hidden-xl"
      >Valor médio faturado</span
    >
    <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" [p-tooltip]="topTooltipExcel" (click)="downloadExcel()"></span>
    <div class="po-text-center billing-value-error" *ngIf="!loading && errorApi">
      <app-error [message]="message"></app-error>
    </div>
    <div class="po-table-main-container" *ngIf="!loading && !errorApi">
      <div class="po-table-wrapper" style="opacity: 1">
        <div>
          <table class="po-table">
            <thead>
              <tr class="po-table-header">
                <th class="po-table-header-ellipsis">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Dia </span>
                  </div>
                </th>
                <th class="po-table-header-ellipsis">
                  <div class="po-table-header-flex">
                    <span class="po-table-header-ellipsis"> Quantidade </span>
                  </div>
                </th>
                <th class="po-table-header-ellipsis">
                  <div class="value-column">
                    <span class="po-table-header-ellipsis"> Valor R$ </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="po-table-group-row" *ngFor="let item of tableItens">
              <tr class="po-table-row">
                <td class="po-table-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <span>{{item.dia}}</span
                    >
                  </div>
                </td>
                <td class="po-table-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <span>{{item.quantidade}}</span>
                  </div>
                </td>
                <td class="po-table-column value-column" ng-reflect-ng-class="">
                  <div class="po-table-column-cell notranslate">
                    <span>{{item.valor}}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </po-widget>
</div>
